module.exports = __webpack_public_path__ + "img/物业icon61.961121d1.png";